import data from 'app-core/data';
import ui from './ui';
import mitt from 'mitt';
import auth from 'app-core/auth';
import { custom } from 'devextreme/ui/dialog';

const eventsBus = mitt();
let vueApp = null;

function setVueApp(v) {
	vueApp = v;
}

const stateStore = {
	_data: {},
	set(key, value) {
		this._data[key] = value;
	},
	get(key, keep = false) {
		const value = this._data[key];
		// Clean up the store after the data is retrieved, unless 'keep' is true
		if (!keep) {
			delete this._data[key];
		}
		return value;
	},
	remove(key) {
		delete this._data[key];
	}
};

function safe(func) {
	if (func)
		try {
			func();
		} catch (ex) {
			if (__DEBUG__)
				console.warn(`Safe execution failed: ${ex}, ${func}`);
		}
}

function notificationsVisible() {
	return true;
}

function confirmMessage(opts) {
	if (!notificationsVisible() && !opts?.force) return;
	let dlg = custom({
		...opts,
		messageHtml: opts.text || opts.message,
		title: opts.title,
		buttons: opts.buttons || [{
			text: 'Yes',
			onClick: (e) => {
				return true;
			}
		}, {
			text: 'No',
			onClick: (e) => {
				return false;
			}
		}]
	});

	let result = dlg.show();
	result.then((dialogResult) => {
		if (opts.onExecute)
			opts.onExecute(dialogResult);
		if (dialogResult && opts.handler)
			opts.handler(dialogResult);
		else if (!dialogResult && opts.cancel)
			opts.cancel(dialogResult);
	});

	return dlg;
}

function confirmAction(title, msg, opts) {
	if (!notificationsVisible() && !opts?.force) return;
	let autoCloseSeconds = opts?.timeout;
	return new Promise((res, rej) => {
		let messageId = data.uuid();
		let dlg = confirmMessage({
			title: title || 'Confirm action',
			text: `<div id="messageBody_${messageId}">${msg || 'Do you want to remove item?'}</div><div class="adthos-dialog-timer-message" id="messageTimer_${messageId}"></div>`,
			handler: () => {
				res(true);
			},
			cancel: () => rej(false),
			...(opts || {})
		});
		let updateMessage = () => document.querySelector(`#messageTimer_${messageId}`).innerHTML = `This message will be closed in ${autoCloseSeconds} seconds.`;
		let checkTimer = () => {
			if (autoCloseSeconds > 0) {
				updateMessage();
				setTimeout(() => {
					if (!autoCloseSeconds) return;

					autoCloseSeconds--;
					if (autoCloseSeconds <= 0) {
						updateMessage();
						if (opts?.onTimeout) {
							opts.onTimeout()
						}
						res(true);
						dlg.hide();
					} else {
						checkTimer();
					}
				}, 1000);
			}
		}
		if (autoCloseSeconds) {
			checkTimer();
		}
	}).finally(() => autoCloseSeconds = null);
}


function getVueApp() {
	return vueApp;
}

export default {
	install(app) {
		setVueApp(app);

		const playConfirmAudio = new Audio(require('assets/confirm.wav'));
		playConfirmAudio.preload = 'auto';
		var playConfirm = () => playConfirmAudio.play();

		const playClickAudio = new Audio(require('assets/click.wav'));
		playClickAudio.preload = 'auto';
		var playClick = () => playClickAudio.play();

		app.config.globalProperties.$Data = data;
		app.config.globalProperties.$notifySuccess = ui.notifySuccess;
		app.config.globalProperties.$notifyError = ui.notifyError;
		app.config.globalProperties.$log = data.log;
		app.config.globalProperties.$eventsBus = eventsBus;
		app.config.globalProperties.$auth = auth;
		app.config.globalProperties.$store = stateStore;
		app.config.globalProperties.$playConfirm = playConfirm;
		app.config.globalProperties.$playClick = playClick;
		app.config.globalProperties.$safe = safe;
		app.config.globalProperties.$confirmMessage = confirmMessage;
		app.config.globalProperties.$confirm = confirmAction;
	},
	stateStore,
	eventsBus,
	safe
};

export {
	eventsBus,
	stateStore,
	safe
}